import { Button, HStack } from "@chakra-ui/react";
import { useDocumentsFilterContext } from "./DocumentsFilterContext";

type FilterActionButtonsProps = {
  onReset: () => void;
  isResetDisabled: boolean;
  onSet: () => void;
  isSetDisabled: boolean;
};

export const FilterActionButtons = ({
  onReset,
  onSet,
  isResetDisabled,
  isSetDisabled,
}: FilterActionButtonsProps) => {
  const { onClose } = useDocumentsFilterContext();

  return (
    <HStack
      justifyContent="space-between"
      borderTopColor="gray.100"
      borderTopWidth={1}
      py={1}
      px={4}
    >
      <Button
        variant="ghost"
        size="sm"
        colorScheme="red"
        onClick={() => {
          onClose();
          onReset();
        }}
        isDisabled={isResetDisabled}
      >
        Reset
      </Button>
      <Button
        variant="ghost"
        size="sm"
        colorScheme="navy"
        onClick={() => {
          onClose();
          onSet();
        }}
        isDisabled={isSetDisabled}
      >
        Set
      </Button>
    </HStack>
  );
};
